module.exports = __webpack_public_path__ + "static/img/nos.6934c0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nos.png
// module id = gicR
// module chunks = 1